import { jsxs, jsx } from 'react/jsx-runtime';
import { Logo } from '../../../../Logo/Logo.es.js';
import { Modal } from '../../../Modal.es.js';

const FullScreenHeader = ({ onCloseClick })=>{
    return jsxs("div", {
        className: "cb-fullscreen-header",
        children: [
            jsx("div", {
                className: "back-wrapper",
                children: jsx(Modal.Back, {
                    icon: "ChevronLeftOutline",
                    iconSize: 24
                })
            }),
            jsx("div", {
                className: "logo-wrapper",
                "data-testid": "circle-logo",
                children: jsx(Logo, {
                    size: 2.5,
                    wordMark: false
                })
            }),
            jsx("div", {
                className: "close-wrapper",
                children: onCloseClick ? jsx(Modal.BasicClose, {
                    className: "close",
                    onClick: onCloseClick
                }) : jsx(Modal.Close, {
                    className: "close"
                })
            })
        ]
    });
};
FullScreenHeader.displayName = 'FullScreen.Header';

export { FullScreenHeader, FullScreenHeader as default };
//# sourceMappingURL=FullScreen.Header.es.js.map
